import * as React from 'react';
import { useSensitivityTooltip_unstable } from './useSensitivityTooltip';
import { renderSensitivityTooltip_unstable } from './renderSensitivityTooltip';
import { useSensitivityTooltipStyles_unstable } from './useSensitivityTooltipStyles';
import type { SensitivityTooltipProps } from './SensitivityTooltip.types';
import type { ForwardRefComponent } from '@fluentui/react-components';

// SensitivityTooltip component - TODO: add more docs
export const SensitivityTooltip: ForwardRefComponent<SensitivityTooltipProps> = React.forwardRef((props, ref) => {
  const state = useSensitivityTooltip_unstable(props, ref);

  useSensitivityTooltipStyles_unstable(state);
  return renderSensitivityTooltip_unstable(state);
});

SensitivityTooltip.displayName = 'SensitivityTooltip';
